import { is, goTo, query, xenv } from '@didi/webx-js'
import { GlobalEnv, sendRecOrderRequest, URLQueries } from '../webx'
import { getTrackUrl, joinEventParams, transformUrl } from './util'
import { inAnyMiniProgram, isAliProgramH5, isPassenger } from './env'
import { navigateToWebx } from './navigateTo'
import {
  clickGoodsGuideMpAppHome,
  getMpAppHomeXenvInfo,
} from '../webx/utils/guide_app_home'

const getPubType = () => {
  switch (true) {
    case !!is('passenger'):
      return 'na'
    case !!(is('weixin') || is('miniprogram')):
      return 'weixin'
    case !!(is('alipay') || is('miniprogram')):
      return 'alipay'
    default:
      return 'others'
  }
}

function isChangpinCard(goods) {
  return goods.goods_type === 3
}

function sendPinchecard(goods, key, label) {
  // priority 76 是畅拼卡，77 是省钱卡。畅拼卡埋1，省钱卡埋2
  // const type = goods.priority === 76 ? 1 : 2
  window.mallTrackEvent(key, '优惠商城推荐位-畅拼卡点击', {
    fr: xenv(),
    pg_type: 3,
    type: goods.priority,
    uid: GlobalEnv.loginInfo.uid,
    ...(goods?.omega_info || {}),
  })
}

export function goodsClick(goods = {}, opts = {}, event) {
  const userInfo = GlobalEnv.loginInfo
  const cityInfo = GlobalEnv.locationInfo
  const { channelId, from, lang, clientType, dchn, atDidao } = GlobalEnv
  switch (opts.source) {
    case 'like': // 猜你喜欢
      window.mallTrackEvent(
        'c_trippackage_mall_detail_collect_ck',
        '统计周期内具体套餐详情页其他产品点击量',
        {
          pid: userInfo.uid,
          taocan_id: opts.detailGoods,
          position: opts.position,
          collect_taocan_id:
            goods.goods_id === undefined
              ? goods.goods_info.goods_id
              : goods.goods_id,
        }
      )
      break
    case 'landpage': // 首页
      // eslint-disable-next-line no-case-declarations
      const url = getTrackUrl()
      window.mallTrackEvent('wyc_trippackage_list_ck', '优惠商城列表页点击', {
        uid: userInfo.uid,
        dchn,
        channel_id: channelId,
        pub_type: getPubType(),
        package_id: goods.goods_id,
        package_type: goods.is_spike,
        g_BizId: goods.product_type,
        package_species: goods.cate_id,
        route_type: goods?.route_type,
      })
      window.mallTrackEvent(
        'c_trippackage_mall_landpage_goods_ck',
        '落地页中所有商品点击',
        {
          pid: userInfo.uid,
          taocan_id:
            goods.goods_id === undefined
              ? goods.goods_info.goods_id
              : goods.goods_id,
          workflow_id:
            event && event.event_info && event.event_info.workflow_id
              ? event.event_info.workflow_id
              : -1,
          uid: userInfo.uid,
          url,
          is_free: goods?.credit_info?.status,
          product_type: goods.product_type,
          city_id: GlobalEnv.locationInfo?.cityId,
          tab_id: goods.cate_id,
          is_dim_p: goods.is_dim_p,
        }
      )
      break
  }

  isChangpinCard(goods) &&
    sendPinchecard(goods, 'wyc_mall_pinchecard_ck', '优惠商城推荐位-畅拼卡点击')
  if (goods.goods_type === 2) {
    isPassenger()
      ? window.mallTrackEvent('na_changxing_card_ck')
      : window.mallTrackEvent('w_changxing_card_ck')
  }

  // let eventPkg = {}
  if (event) {
    const eventParams = Object.assign({}, event.event_info, {
      item_id:
        goods.goods_id === undefined
          ? goods.goods_info.goods_id
          : goods.goods_id,
      expose_page: goods.algorithmEventPageInfo.page,
      expose_pos: goods.algorithmEventPageInfo.index,
      event_type: 'ck',
      event_time: Date.now(),
    })
    // 上报智能算法点击事件
    sendRecOrderRequest(eventParams, event.event_url)
  }
  let url = ''
  let sameProduct = true
  let packageType = ''
  //  这个不是接口请求，拼在 URL 上的 ，确认一下？
  let params = {
    channelId: channelId,
    lang: lang,
    client_type: clientType,
    access_key_id: opts.access_key_id,
    dchn: dchn || '',
    uid: userInfo.uid,
    source_disable_dchn: URLQueries.getQuery('source_disable_dchn'),
    show_version: goods.show_version,
    only_show_cate: URLQueries.getQuery('only_show_cate') || '', // 仅展示某种类目的id，详情页有转主态的操作，因此需要一直携带
    __isBeatles: URLQueries.getQuery('__isBeatles'),
  }
  if (xenv() !== 'passenger') {
    if (opts.trip_cityid || cityInfo.cityId) {
      Object.assign(params, {
        trip_cityid: opts.trip_cityid,
        cityid: cityInfo.cityId,
      })
    }
    if (cityInfo.lat || cityInfo.lng) {
      Object.assign(params, {
        lat: cityInfo.lat,
        lng: cityInfo.lng,
      })
    }
  }
  const xenvInfo = getMpAppHomeXenvInfo(goods)
  if (xenvInfo && xenvInfo.otherDetailPageJumpAppHome) {
    clickGoodsGuideMpAppHome(xenvInfo, params)
    return
  }
  let pathname = ''
  // 拼车周卡
  if (goods.link_url) {
    sameProduct = goods.link_url.indexOf('quartz-mall') > -1
    params.from = from
    if (inAnyMiniProgram()) {
      params.source = 'mpstore'
    }
    url = goods.link_url
    // eventPkg && Object.assign(params, eventPkg)
    if (goods.goods_type === 3) {
      // 拼车卡
      if (goods.goods_name.indexOf('7天') > -1) {
        packageType = 7
      } else if (goods.goods_name.indexOf('30天') > -1) {
        packageType = 30
      }
    }
  } else {
    params = {
      ...params,
      id:
        goods.goods_id === undefined
          ? goods.goods_info.goods_id
          : goods.goods_id,
      prev: opts.source || 0,
      from: from,
    }
    switch (goods.is_spike) {
      case 1:
      case 2: // 秒杀
        Object.assign(params, {
          pid: 10002, // 商城业务id
        })
        pathname = `goodsDetail`
        break
      default:
        // 普通商品
        pathname = `goodsDetail`
        break
    }
    event &&
      Object.assign(params, {
        eventParams: joinEventParams(event.event_info),
      })
  }
  window.mallTrackEvent('coupon_package_ck', '从套餐列表点击跳转详情', {
    pid: userInfo.uid,
    channelId: channelId,
    iterm_type: goods.goods_type === 3 ? 4 : 0,
    card_type: packageType,
    price: goods.price,
  })
  params.openid =
    URLQueries.getQuery('openid') ||
    URLQueries.getQuery('openId') ||
    URLQueries.getQuery('open_id')
  if (url) {
    const queries = {
      ...query(),
    }
    if (!sameProduct) {
      delete queries.xbiz
      delete queries.prod_key
      delete queries.xpsid
      delete queries.xpsid_from
      delete queries.xpsid_share
    }
    if (isPassenger()) {
      delete queries.lat
      delete queries.lng
      delete queries.trip_cityid
      delete queries.cityid
      delete queries.city_id
      delete queries.cityId
    }
    if (goods.link_url && queries.hideNavigation) {
      delete queries.hideNavigation
    }
    const __params = {
      ...queries,
      ...params,
      ts: Date.now(),
      token: userInfo.token,
      source: 'mall', // 来自商城跳转的标识
    }
    console.log('111goto params:', __params)
    goTo({
      url,
      params: __params,
      extParams: {
        h5JumpMethod: 'openPage',
        sameProduct,
      },
    })

    return
  }
  console.log('222goto params:', params)
  setTimeout(() => {
    if (atDidao) {
      // const origin = window.location.origin
      // const _pathname = window.location.pathname.replace(
      //   'index.html',
      //   `${pathname}.html`
      // )
      url = transformUrl('index')
      goTo({
        url,
        params,
        extParams: {
          h5JumpMethod: 'openPage',
          sameProduct,
        },
      })
    } else {
      // 支付宝小程序 webview，不给拼 token 的话，跳过去登录状态就丢失了，原因待定。
      if (isAliProgramH5()) {
        Object.assign(params, {
          token: userInfo.token,
        })
      }
      if (isPassenger()) {
        Object.assign(params, {
          fusion_enable_off_mode: 1,
        })
      }
      // navigateToWebx中处理链接转换
      navigateToWebx({
        pathname: pathname,
        query: params,
        openPage: true,
      })
    }
  }, 0)
}
